import './NotificationTemplate.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  title: string;
  body: string;
}

export const NotificationTemplate = observer(
  (props: IProps): ReactElement => (
    <div className='notification-template'>
      <div className='notification-template-title'>{props.title}</div>
      <div>{props.body}</div>
    </div>
  )
);
